import { render, staticRenderFns } from "./ReportSections.vue?vue&type=template&id=59bc352c&scoped=true&"
import script from "./ReportSections.vue?vue&type=script&lang=js&"
export * from "./ReportSections.vue?vue&type=script&lang=js&"
import style0 from "../report-card.css?vue&type=style&index=0&lang=css&"
import style1 from "./ReportSections.vue?vue&type=style&index=1&id=59bc352c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bc352c",
  null
  
)

export default component.exports